import React from 'react';

// New / Repair selector shared by Acquisition, Receive Pending Order, and the
// Bound Book edit form. Values match the chk_acquisition_type constraint.
const OPTIONS = [
  { value: 'NEW', label: 'New' },
  { value: 'REPAIR', label: 'Repair' },
];

export default function AcquisitionTypeToggle({ value, onChange }) {
  return (
    <div>
      <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
        Acquisition Type
      </label>
      <div className="flex gap-2">
        {OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            className={`flex-1 rounded-md px-3 py-2 text-sm font-medium border transition-colors ${
              value === opt.value
                ? 'bg-primary-50 border-primary-300 text-primary-700 dark:bg-primary-900/30 dark:border-primary-700 dark:text-primary-300'
                : 'bg-white border-slate-300 text-slate-600 hover:bg-slate-50 dark:bg-slate-800 dark:border-slate-700 dark:text-slate-400'
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
